import { useTranslation } from "react-i18next";
import { NewUserWelfareWrap } from "./atom";

export function NewUserWelfareBar({
  days,
  hours,
  minutes,
  seconds,
  tips,
}: {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  tips: string;
}) {
  const { t } = useTranslation("topup");
  return (
    <NewUserWelfareWrap>
      <div className="title">{t("picture_new_user_recharge")}</div>
      <div className="welfare-content">
        <span className="sub-title">{t("picture_new_user_welfare")}</span>
        <span>{tips}</span>
        <span className="line">|</span>
        <span className="sub-title">{t("picture_new_user_welfare_time")}</span>
        <span>
          {days}
          {t("picture_new_user_welfare_days")}
        </span>
        {(hours || minutes || seconds) && (
          <div className="count-down">
            <div>{hours}</div>:<div>{minutes}</div>:<div>{seconds}</div>
          </div>
        )}
      </div>
    </NewUserWelfareWrap>
  );
}
